import React, { useState } from "react";
import { ChevronDown, HelpCircle, ShieldCheck, Tag, CreditCard } from "lucide-react";

export default function FaqModern() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      icon: CreditCard,
      question: "How can I subscribe and pay for EMIBOOK?",
      answer:
        "Download the EMIBOOK app from the Google Play Store, choose your preferred plan, and pay securely online within the application. Once payment is successful, your subscription is activated immediately.",
    },
    {
      icon: ShieldCheck,
      question: "What is your 7-Day Refund Policy?",
      answer:
        "We offer refunds within 7 days of purchase for registered subscribers. Contact customer service at support@emibook.in or +91 9036770772 with your purchase receipt. A credit will automatically be applied to your original payment method within TWO working days after acknowledgment.",
    },
    {
      icon: Tag,
      question: "Do you offer discounts for bulk subscriptions?",
      answer:
        "Yes, we provide enterprise discounts to Brands and Retail Associations who subscribe in bulk. Please reach out to our team at support@emibook.in to discuss custom volume arrangements.",
    },
    {
      icon: HelpCircle,
      question: "What can I manage in EMIBOOK?",
      answer:
        "EMIBOOK covers the full loan cycle: borrower records with contact details and KYC, EMI schedules with their tenures and due dates, payments logged with a transaction number and payment proof, and the running transaction history behind all of it.",
    },
  ];

  return (
    <section
      id="faq"
      className="section-surface"
      style={{
        paddingTop: "90px",
        paddingBottom: "90px",
      }}
    >
      <div className="container">
        {/* Section Header */}
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-7">
            <span className="badge-label mb-2">FAQ</span>
            <h2
              className="section-title"
              style={{
                marginTop: "8px",
                marginBottom: "12px",
              }}
            >
              Frequently Asked Questions
            </h2>
            <p className="section-subtitle">
              Straightforward answers about subscriptions, refunds, and managing your book.
            </p>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {faqs.map((faq, idx) => {
                const Icon = faq.icon;
                const isOpen = openIndex === idx;
                return (
                  <div
                    key={idx}
                    className="card-clean"
                    style={{
                      borderRadius: "14px",
                      border: isOpen ? "1px solid #2563eb" : "1px solid #e2e8f0",
                      overflow: "hidden",
                    }}
                  >
                    <button
                      onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                      style={{
                        width: "100%",
                        padding: "18px 22px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        textAlign: "left",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "8px",
                            background: isOpen ? "rgba(37, 99, 235, 0.08)" : "#f1f5f9",
                            color: isOpen ? "#2563eb" : "#64748b",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <Icon size={16} />
                        </div>
                        <span
                          style={{
                            fontFamily: "var(--font-display)",
                            fontSize: "0.98rem",
                            fontWeight: 600,
                            color: isOpen ? "#2563eb" : "#0f172a",
                          }}
                        >
                          {faq.question}
                        </span>
                      </div>
                      <ChevronDown
                        size={18}
                        color={isOpen ? "#2563eb" : "#64748b"}
                        style={{
                          transform: isOpen ? "rotate(180deg)" : "none",
                          transition: "transform 0.2s ease",
                          flexShrink: 0,
                          marginLeft: "12px",
                        }}
                      />
                    </button>

                    {isOpen && (
                      <div
                        style={{
                          padding: "0 22px 20px 66px",
                          color: "#475569",
                          fontSize: "0.92rem",
                          lineHeight: 1.65,
                        }}
                      >
                        {faq.answer}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
